// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseMapstringint } from '../../types';

/**
 * countUnreadMessages
 *
 * @export
 * @tags message-user-notification-controller
 * @link [GET] /messageUserNotifications/unreadCount
 */
export function getMessageUserNotificationsUnreadCount(): Promise<BaseResponseMapstringint>;
export function getMessageUserNotificationsUnreadCount(
    options: ApiOptions<never, never>
): Promise<BaseResponseMapstringint>;
export function getMessageUserNotificationsUnreadCount(
    options?: ApiOptions<never, never>
): Promise<BaseResponseMapstringint> {
    return request<never, never, never>('/messageUserNotifications/unreadCount', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getMessageUserNotificationsUnreadCount',
    });
}

export const meta = [
    {
        tags: ['message-user-notification-controller'],
        path: '/messageUserNotifications/unreadCount',
        method: 'get',
    },
];
